import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { TFunction } from 'react-i18next';
import { Action, withInject } from '@piwikpro/platform';
import {
  Stack,
  Text,
  withTranslation,
} from '@piwikpro/ui-components';
import { MetaSitesState } from '@piwikpro/meta-sites-crate/reducers';

const mapStateToProps = (state: MetaSitesState) => ({
  metaSite: state.metaSites.details.settings.settings,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  metaSites: any
}

interface Props extends ReduxProps, InjectedProps {
  t: TFunction
}

class SharepointIntegration extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, { setFieldValue, setSubmitting }) {
    const { metaSites, metaSite } = this.props;

    try {
      await metaSites.updateMetaSite(metaSite.id, values);
    } catch (err) {
      setFieldValue('sharepoint_integration', !values.sharepoint_integration, false);
    }

    setSubmitting(false);
  }

  render() {
    const {
      metaSite,
      t,
    } = this.props;

    return (
      <Stack wrap verticalAlignment="center">
        <Stack.Item fill>
          <Stack vertical spacing="narrow">
            <Stack.Item>
              <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.sharepoint.title')}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text as="p">{t('apps.details.settings.sharepoint.description')}</Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Action.AutoSavedSwitcherControl
            id="meta-site-settings-sharepoint-integration"
            initialValue={metaSite.attributes.sharepoint_integration}
            name="sharepoint_integration"
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
      </Stack>
    );
  }
}

export default connector(withInject<InjectedProps>({
  metaSites: 'MetaSitesCrate.metaSites',
})(
  withTranslation(['administration'])(SharepointIntegration),
));
